module.exports = __webpack_public_path__ + "static/media/question.01933495.svg";